import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { I18nService } from '../shared/i18n.service';

@Component({
    selector: 'app-inkoop-ontvangst-jmodal',
    templateUrl: './ontvangst-modal.page.html',
    styleUrls: ['./ontvangst-modal.page.scss'],
    standalone: false,
})
export class InkoopOntvangstModalPage implements OnInit {
    public details: any = null;
    public receivedQty: number;
    public isLoading = true;
    private readonly id: number;

    constructor(
        private modalCtrl: ModalController,
        private navParams: NavParams,
        private ajax: AjaxService,
        private toastCtrl: ToastController,
        private global: GlobalService,
        public i18n: I18nService
    ) {
        // ? id from main inkoop page ()
        this.id = this.navParams.get('id');
    }

    ngOnInit() {
        this.loadDetails();
    }
    loadDetails() {
        this.isLoading = true;
        this.ajax
            .get('getInkoopRegelDetails', { id: this.id })
            .then((data: any) => {
                this.isLoading = false;
                this.details = data.details;
            })
            .catch((err: any) => {
                this.isLoading = false;
                console.error(err);
                this.presentToast(
                    this.i18n.tr('[en]Error loading details.'),
                    'danger'
                );
                // this.presentToast(JSON.stringify(err, null, 2), 'danger');
            });
    }

    // ? rteurns the remaining quantity to receive (e.g. if Besteld is 100 and Ontvange is 29, the function will make the receivedQty to 71 )
    fillRemaining() {
        if (this.details) {
            const ordered = parseFloat(this.details.Besteld) || 0;
            const received = parseFloat(this.details.Ontvangen) || 0;
            const remaining = ordered - received;
            // TODO : need to test if this rounding to 2 decimal places is not causing errors. (should be in theory, as most Besteld are in whole numbers)
            this.receivedQty =
                remaining > 0 ? parseFloat(remaining.toFixed(2)) : 0;
        }
    }

    save() {
        if (!this.receivedQty || this.receivedQty <= 0) {
            this.presentToast(
                this.i18n.tr('[en]Please enter a valid quantity.'),
                'warning'
            );
            return;
        }
        this.ajax
            .get('updateInkoopOntvangst', {
                id: this.id,
                qty: this.receivedQty,
                username: this.global.username,
            })
            .then((data: any) => {
                if (data.status === 'OK') {
                    this.presentToast(
                        this.i18n.tr('[en]Quantity updated sucesfully!'),
                        'success'
                    );
                    this.modalCtrl.dismiss({ updated: true });
                } else {
                    this.presentToast(
                        data.error || this.i18n.tr('[en]Failed to update.'),
                        'danger'
                    );
                }
            })
            .catch((err) => {
                console.error(err);
                this.presentToast(
                    this.i18n.tr('[en]Failed to update quantity.'),
                    'danger'
                );
            });
    }
    dismiss() {
        this.modalCtrl.dismiss();
    }

    async presentToast(message: string, color: string) {
        const toast = await this.toastCtrl.create({
            // position: 'middle',
            message: message,
            duration: 3000,
            color: color,
        });
        toast.present();
    }
}
